import UserInfo from './UserInfo';

export type { UserInfoProps } from './UserInfo';
export default UserInfo;
